import { RootState } from '../../store';

export const getTotalPagesSelector = (state: RootState) => state.ticketReducer.totalPages;
export const getCurrentPageSelector = (state: RootState) => state.ticketReducer.currentPage;
